module.exports = __webpack_public_path__ + "media/application/images/2018/instagram-red@2x-d96d2084bcd878ac4b3f73fe55a92591.png";